import React, {useEffect, useState} from 'react';
import {IonContent, IonModal, IonPage} from '@ionic/react';
import {useHistory, useParams} from "react-router-dom";
import {ApiService} from "../api/ApiService";
import {LpSettlement} from "../api/model/LpSettlement";
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { ChevronRight } from '../components/icons';
import { useLogPageVisit } from '../utils/logPageVisit';

const PaycheckDetail: React.FC = () => {
    useLogPageVisit('LP Check Paycheck', 'User viewed paycheck details');
    const history = useHistory();
    const { onSheet, onIonScroll } = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [checkInfo, setCheckInfo] = useState<LpSettlement>();
    const [revenueOrderArray, setRevenueOrderArray] = useState<any[]>([]);
    const [deductionsOrderArray, setDeductionsOrderArray] = useState<any[]>([]);
    const [reimBursementsArray, setReimBursementsArray] = useState<any[]>([])
    const [activeOrder, setActiveOrder] = useState<any[]>([]);
    const [activeOrderNumber, setActiveOrderNumber] = useState("");
    const [activeDeduction, setActiveDeduction] = useState<any>({});
    const [activeDeductionDesc, setActiveDeductionDesc] = useState("");
    const [activeOrigin, setActiveOrigin] = useState<any>({});
    const [activeReimbursementsOrigin, setActiveReimbursementsOrigin] = useState("");

    let {checkno}: any = useParams();

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        ApiService.lpSettlementGet('paycheckDetail', {checknum: checkno}).then(it => {
            processData(it.settlement);
            getOrders(it.settlement);
        });
    }, []);

    const processData = (settlement: any) => {
        let items = settlement
        let info: any = {revenue: [], deductions: [], general: [], reimbursements: []}
        Object.keys(items).forEach((element: any) => {
            if (element === 'revenue') {
                info.revenue = parseObj(items[element])
            } else if (element === 'general') {
                items[element].total = Math.ceil(items[element].total * 100) / 100
                info.general = items[element]
            } else if (element === 'reimbursements') {
                info.reimbursements = parseObj(items[element])
            } else {
                info.deductions = parseObj(items[element])
            }
        });
        setIsLoading(false)
        setCheckInfo(info)
    }

    function parseObj(items: any) {
        let tempArray: any[] = []
        items.forEach((element: any) => {
            tempArray.push(element)
        });
        return tempArray;
    }

    function getOrders(settlement: any) {
        let tempReveuneArray: any[] = [];
        let tempDeductionArray: any[] = [];
        let tempReimbursmentsArray: any[] = [];
        settlement.revenue.forEach((element: any) => {
            if (!tempReveuneArray.includes(element.order) && element.order !== "       ") {
                tempReveuneArray.push(element.order)
            } else if (element.order === "       " || element.order === null) {
                tempReveuneArray.push("Additional Pay")
            }
        });
        settlement.deductions.forEach((element: any) => {
            if (!tempDeductionArray.includes(element.desc)) {
                tempDeductionArray.push(element.desc)
            }
        })
        settlement.reimbursements.forEach((element: any) => {
            if (!tempReimbursmentsArray.includes(element.origin)) {
                tempReimbursmentsArray.push(element.origin)
            }
        })
        setRevenueOrderArray(tempReveuneArray);
        setDeductionsOrderArray(tempDeductionArray);
        setReimBursementsArray(tempReimbursmentsArray);
    }

    const pullRevenueInfo = (order: string) => {
        let tempArray: any[] = []
        checkInfo?.revenue.forEach((element: any) => {
            if (element.order === order || element.order === "       ") {
                tempArray.push(element);
            }
        });
        setActiveOrder(tempArray);
        setShowModal1(true)
    }

    const pullDeductionInfo = (desc: string) => {
        let tempArray: {} = {}
        checkInfo?.deductions.forEach((element: any) => {
            if (element.desc === desc) {
                tempArray = element;
            }
        });
        setActiveDeduction(tempArray);
        setShowModal2(true)
    }

    const pullReimbursmentInfo = (origin: string) => {
        let tempArray: {} = {}
        checkInfo?.reimbursements.forEach((element: any) => {
            if (element.origin === origin) {
                tempArray = element;
            }
        });
        setActiveOrigin(tempArray);
        setShowModal3(true)
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/settlements');
    };

    const settlementDate = checkInfo?.general?.date
      ? checkInfo.general.date.substr(5) + '-' + checkInfo.general.date.substr(0, 4)
      : '—';

    return (
        <IonPage>
            <LoadDetailHeader title="Settlement Details" onBack={goBack} onSheet={onSheet} />
            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
                <IonModal isOpen={showModal1} cssClass='my-custom-class'>
                    <div className="design-a design-a--mounted" style={{ minHeight: '100%', background: 'var(--home-app-bg)' }}>
                        <div className="home-sheet advance-sheet" style={{ paddingTop: 32 }}>
                            <div className="advance-card">
                                <div className="advance-card__title">
                                    {activeOrderNumber !== "Additional Pay" ? `Order: ${activeOrderNumber}` : "Additional Pay"}
                                </div>
                                <div className="inspection-list" style={{ marginTop: 8 }}>
                                    {activeOrder?.map((element, idx) => (
                                        <div key={idx} className="photo-card" style={{ marginBottom: 10 }}>
                                            <div className="inspection-list">
                                                <div className="inspection-row">
                                                    <span className="inspection-row__label">Origin</span>
                                                    <span className="advance-card__body">
                                                        {element.origin !== null && element.origin !== ", null" ? element.origin : 'N/A'}
                                                    </span>
                                                </div>
                                                {element.destination !== null && element.destination !== ", null" && element.destination !== "" ? (
                                                    <div className="inspection-row">
                                                        <span className="inspection-row__label">Destination</span>
                                                        <span className="advance-card__body">{element.destination}</span>
                                                    </div>
                                                ) : null}
                                                <div className="inspection-row">
                                                    <span className="inspection-row__label">Dispatch Number</span>
                                                    <span className="advance-card__body">{element.disp}</span>
                                                </div>
                                                {element.loadedMiles !== null ? (
                                                    <div className="inspection-row">
                                                        <span className="inspection-row__label">Loaded Miles</span>
                                                        <span className="advance-card__body">{element.loadedMiles}</span>
                                                    </div>
                                                ) : null}
                                                {element.loadedRate !== null ? (
                                                    <div className="inspection-row">
                                                        <span className="inspection-row__label">Loaded Rate</span>
                                                        <span className="advance-card__body">{element.loadedRate}</span>
                                                    </div>
                                                ) : null}
                                                <div className="inspection-row">
                                                    <span className="inspection-row__label">Additional Pay</span>
                                                    <span className="advance-card__body">${Math.round(element.addlPay * 100) / 100}</span>
                                                </div>
                                                <div className="inspection-row">
                                                    <span className="inspection-row__label">Amount Due</span>
                                                    <span className="advance-card__title">${Math.round(element.dueOwner * 100) / 100}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button type="button" className="profile-submit" onClick={() => setShowModal1(false)}>Done</button>
                            </div>
                        </div>
                    </div>
                </IonModal>

                <IonModal isOpen={showModal2} cssClass='my-custom-class'>
                    <div className="design-a design-a--mounted" style={{ minHeight: '100%', background: 'var(--home-app-bg)' }}>
                        <div className="home-sheet advance-sheet" style={{ paddingTop: 32 }}>
                            <div className="advance-card">
                                <div className="advance-card__title">{activeDeductionDesc}</div>
                                <div className="inspection-list" style={{ marginTop: 8 }}>
                                    <div className="inspection-row">
                                        <span className="inspection-row__label">Order #</span>
                                        <span className="advance-card__body">{activeDeduction.order !== null ? activeDeduction.order : 'N/A'}</span>
                                    </div>
                                    <div className="inspection-row">
                                        <span className="inspection-row__label">Date</span>
                                        <span className="advance-card__body">{activeDeduction.date}</span>
                                    </div>
                                    <div className="inspection-row">
                                        <span className="inspection-row__label">Description</span>
                                        <span className="advance-card__body">{activeDeduction.desc}</span>
                                    </div>
                                    {activeDeduction.leaseBegin !== null ? (
                                        <div className="inspection-row">
                                            <span className="inspection-row__label">Lease Beginning</span>
                                            <span className="advance-card__body">${Math.round(activeDeduction.leaseBegin * 100) / 100}</span>
                                        </div>
                                    ) : null}
                                    {activeDeduction.leaseEnd !== null ? (
                                        <div className="inspection-row">
                                            <span className="inspection-row__label">Lease End</span>
                                            <span className="advance-card__body">${Math.round(activeDeduction.leaseEnd * 100) / 100}</span>
                                        </div>
                                    ) : null}
                                    <div className="inspection-row">
                                        <span className="inspection-row__label">Amount</span>
                                        <span className="advance-card__title">${Math.round(activeDeduction.amount * 100) / 100}</span>
                                    </div>
                                </div>
                                <button type="button" className="profile-submit" onClick={() => setShowModal2(false)}>Done</button>
                            </div>
                        </div>
                    </div>
                </IonModal>

                <IonModal isOpen={showModal3} cssClass='my-custom-class'>
                    <div className="design-a design-a--mounted" style={{ minHeight: '100%', background: 'var(--home-app-bg)' }}>
                        <div className="home-sheet advance-sheet" style={{ paddingTop: 32 }}>
                            <div className="advance-card">
                                <div className="advance-card__title">{activeReimbursementsOrigin}</div>
                                <div className="inspection-list" style={{ marginTop: 8 }}>
                                    <div className="inspection-row">
                                        <span className="inspection-row__label">CD #</span>
                                        <span className="advance-card__body">{Math.round(activeOrigin.cd * 100) / 100}</span>
                                    </div>
                                    <div className="inspection-row">
                                        <span className="inspection-row__label">Origin</span>
                                        <span className="advance-card__body">{Math.round(activeOrigin.origin * 100) / 100}</span>
                                    </div>
                                    <div className="inspection-row">
                                        <span className="inspection-row__label">Due to Owner</span>
                                        <span className="advance-card__title">${Math.round(activeOrigin.dueOwner * 100) / 100}</span>
                                    </div>
                                </div>
                                <button type="button" className="profile-submit" onClick={() => setShowModal3(false)}>Done</button>
                            </div>
                        </div>
                    </div>
                </IonModal>

                <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                    <div className="home-hero advance-hero">
                        <div className="advance-hero__eyebrow">Settlement Date: {settlementDate}</div>
                        <div className="advance-hero__title home-display">
                            {!isLoading ? `$${checkInfo?.general.total}` : 'Loading…'}
                        </div>
                        <div className="advance-hero__meta">
                            {!isLoading ? `Check #${checkInfo?.general.checknum} · Unit ${checkInfo?.general.unit}` : ''}
                        </div>
                    </div>

                    <div className="home-sheet advance-sheet">
                        <div className="photo-card">
                            <div className="inspection-card__title">Summary</div>
                            <div className="inspection-list">
                                <div className="inspection-row">
                                    <span className="inspection-row__label">Loaded Miles</span>
                                    <span className="advance-card__body">{!isLoading ? checkInfo?.general.loadedMiles : '—'}</span>
                                </div>
                                <div className="inspection-row">
                                    <span className="inspection-row__label">Revenue</span>
                                    <span className="advance-card__body">${!isLoading ? checkInfo?.general.revenue : '—'}</span>
                                </div>
                                <div className="inspection-row">
                                    <span className="inspection-row__label">Deductions</span>
                                    <span className="advance-card__body">${!isLoading ? checkInfo?.general.deductions : '—'}</span>
                                </div>
                                <div className="inspection-row">
                                    <span className="inspection-row__label">Reimbursements</span>
                                    <span className="advance-card__body">${!isLoading ? checkInfo?.general.reimbursements : '—'}</span>
                                </div>
                                <div className="inspection-row">
                                    <span className="inspection-row__label">Total</span>
                                    <span className="advance-card__title">${!isLoading ? checkInfo?.general.total : '—'}</span>
                                </div>
                            </div>
                        </div>

                        <div className="photo-card">
                            <div className="inspection-card__title">Revenue</div>
                            {isLoading ? (
                                <p className="photo-empty">Loading…</p>
                            ) : revenueOrderArray.length === 0 ? (
                                <p className="photo-empty">No revenue line items.</p>
                            ) : (
                                <div className="inspection-list">
                                    {revenueOrderArray.map((revenue, idx) => (
                                        <button
                                            type="button"
                                            className="history-load"
                                            key={idx}
                                            onClick={() => { setActiveOrderNumber(revenue); pullRevenueInfo(revenue); }}
                                        >
                                            <div className="history-load__body">
                                                <div className="history-load__meta">
                                                    {revenue !== "Additional Pay" ? `Order: ${revenue}` : "Additional Pay"}
                                                </div>
                                            </div>
                                            <ChevronRight />
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="photo-card">
                            <div className="inspection-card__title">Deductions</div>
                            {isLoading ? (
                                <p className="photo-empty">Loading…</p>
                            ) : deductionsOrderArray.length === 0 ? (
                                <p className="photo-empty">No deductions.</p>
                            ) : (
                                <div className="inspection-list">
                                    {deductionsOrderArray.map((item, idx) => (
                                        <button
                                            type="button"
                                            className="history-load"
                                            key={idx}
                                            onClick={() => { setActiveDeductionDesc(item); pullDeductionInfo(item); }}
                                        >
                                            <div className="history-load__body">
                                                <div className="history-load__meta">{item}</div>
                                            </div>
                                            <ChevronRight />
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="photo-card">
                            <div className="inspection-card__title">Reimbursements</div>
                            {isLoading ? (
                                <p className="photo-empty">Loading…</p>
                            ) : reimBursementsArray.length === 0 ? (
                                <p className="photo-empty">No reimbursements.</p>
                            ) : (
                                <div className="inspection-list">
                                    {reimBursementsArray.map((item, idx) => (
                                        <button
                                            type="button"
                                            className="history-load"
                                            key={idx}
                                            onClick={() => { setActiveReimbursementsOrigin(item); pullReimbursmentInfo(item); }}
                                        >
                                            <div className="history-load__body">
                                                <div className="history-load__meta">{item}</div>
                                            </div>
                                            <ChevronRight />
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default PaycheckDetail;
